import React, { useState, useEffect } from "react";
import { COLOR_GRAY_BANNER_BACKGROUND } from "../../../constants/general-constants";
import {SYSTEM_BLUE_BACKGROUND_LIGHT} from "../../../constants/general-constants";

export default function UtilisationFloorPlanDateTimeTicker() {
  const [currentDate, setCurrentDate] = useState(new Date(2025, 6, 1, 0, 0, 0)); 
  // 6 = July (0-based months in JS)

  useEffect(() => {
    const endDate = new Date(2025, 6, 15, 23, 0, 0);

    const interval = setInterval(() => {
      setCurrentDate(prevDate => {
        let nextDate = new Date(prevDate);
        nextDate.setHours(prevDate.getHours() + 1);

        if (nextDate > endDate) {
          return new Date(2025, 6, 1, 0, 0, 0); // restart cycle
        }
        return nextDate;
      });
    }, 3000); // speed of animation (1 sec per simulated hour)

    return () => clearInterval(interval);
  }, []);

  // Format outputs
  const displayDayDate = currentDate.toLocaleDateString("en-GB", {
    weekday: "long",
    day: "numeric",
    month: "short"
  });

  const displayTime = currentDate.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit"
  });

  const dayDate = { fontSize: "14px", fontWeight: "bold" };
  const time = { fontSize: "18px", fontWeight: "bold", marginTop: "4px" };

  return (
    <div style={{ alignItems:'top', backgroundColor: SYSTEM_BLUE_BACKGROUND_LIGHT, color: "#fff", padding: '10px', textAlign: 'center' }}>
      <div style={dayDate}>{displayDayDate}</div>
      <div style={time}>{displayTime}</div>
    </div>
  );
}




